// eslint-disable-next-line import/no-duplicates
import ja from "date-fns/locale/ja";
// eslint-disable-next-line import/no-duplicates
import { format, parse } from "date-fns";

export const numberFormat = (num: Number) => {
  return (num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
};
export const moneyFormat = (num: Number) => {
  return "￥" + (num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
};
export const dateToYYYYMMDDWithLocale = (date: string) => {
  if (!date) return "";
  return format(parse(date, "yyyy-MM-dd", new Date()), "yyyy年MM月dd日", { locale: ja });
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    numberFormat: (num: Number) => string;
    moneyFormat: (num: Number) => string;
    dateToYYYYMMDDWithLocale: (date: string) => string;
  }
}
